export default __webpack_public_path__ + "static/media/nexus-hero.d41ec7bf.mp4";